import { useEffect, useState } from 'react';
import { api } from '../api/endpoints';

/** Виды справочника причин, коды которых встречаются в журнале изменений заказа. */
const KINDS = ['not_delivered', 'pickup_failed', 'cancel', 'return_to_ct', 'rejection'] as const;

type Names = Readonly<Record<string, string>>;

const cache = new Map<string, Promise<Names>>();

async function load(): Promise<Names> {
  const lists = await Promise.all(KINDS.map((kind) => api.reasonCodes(kind).catch(() => [])));

  return Object.fromEntries(lists.flat().map((item) => [item.code, item.name]));
}

/**
 * Названия причин из справочника заказчика: код → слова на языке интерфейса.
 *
 * Справочник один на весь кабинет и меняется редко, поэтому загружается один раз на
 * язык, а не на каждую строку журнала. Пока не загружен — пустой словарь, и запись
 * показывает код, как и любой неизвестный.
 */
export function useReasonNames(locale: string): Names {
  const [names, setNames] = useState<Names>({});

  useEffect(() => {
    let alive = true;
    let pending = cache.get(locale);

    if (pending === undefined) {
      pending = load();
      cache.set(locale, pending);
    }

    void pending.then((value) => {
      if (alive) {
        setNames(value);
      }
    });

    return () => {
      alive = false;
    };
  }, [locale]);

  return names;
}
